import { GitBranch } from "lucide-react";
import type { Task } from "../../mock/types";
import { PrBadge } from "../bits";

export function GithubSection({ task }: { task: Task }) {
	if (!task.github) return null;
	const { branch_name, pr_state, pr_number } = task.github;

	return (
		<section>
			<div className="mb-3 flex items-center gap-2">
				<GitBranch className="h-4 w-4 text-muted" />
				<h3 className="text-sm font-semibold text-foreground">GitHub</h3>
			</div>
			<div className="flex items-center gap-2 rounded-lg border border-border bg-surface px-3 py-2">
				<code className="flex-1 truncate text-xs text-foreground font-mono">
					{branch_name}
				</code>
				<PrBadge state={pr_state} prNumber={pr_number} />
			</div>
		</section>
	);
}
